var _defs, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNvax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b4dfffb4-be6c-452e-85cf-5109369540cf",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-07d7321c-c365-4726-a6ad-29573ac92675{fill:url(#uuid-56bbe965-2e74-4407-b9aa-054626ce2fd9);}.uuid-07d7321c-c365-4726-a6ad-29573ac92675,.uuid-8e974dc5-f8ad-4336-88b5-f2c5e95ca771,.uuid-1f1cc64f-df2d-4f47-9383-83725213929a,.uuid-ca6ce922-5a49-4ccc-b845-a54f2980c30b,.uuid-85a65ebe-10a2-4a06-a994-d5e7a3bcff3c,.uuid-6021dbf1-982a-49a4-85a1-97a826cbc652,.uuid-13583201-fdb1-43a8-a8b3-271a508b8af4,.uuid-1a2c85b1-8fe4-40db-be1c-d2b6f8c43e37,.uuid-a3fb4f95-bc02-4965-9b78-241cb26bb266,.uuid-132fc7e1-afc7-45b7-8a74-663d95c33ecd,.uuid-572d6267-88af-4620-9f3a-72d30b9c7a7c,.uuid-042ec937-9207-42ac-a7f7-7ed60c267ea4,.uuid-fa9ae6c7-94ce-454b-a914-05d2b828eaaa,.uuid-efbc5224-a8cc-4c97-920e-009ec1b6bf45,.uuid-dd9b37a8-2fe4-49bf-9af6-340e83887068,.uuid-e7dca424-e3fe-4a49-8f5f-4d3100321e43,.uuid-7eb5f371-40bf-4ee9-b9ce-677e4f52bca8,.uuid-2c7a09e4-9fec-422b-8a85-081382ad7c93,.uuid-e4c97611-e2f6-4123-a7a9-b096e97afc94{fill-rule:evenodd;}.uuid-a4f0668e-e2d4-48b5-8cde-8d813c6273f9{fill:#fff;}.uuid-8e974dc5-f8ad-4336-88b5-f2c5e95ca771{fill:#faae3f;}.uuid-1f1cc64f-df2d-4f47-9383-83725213929a{fill:url(#uuid-44afb8e2-a108-4924-b918-4e7452b1de83);}.uuid-ca6ce922-5a49-4ccc-b845-a54f2980c30b{fill:url(#uuid-10b43388-ad0d-418e-a836-c2a1857d3911);}.uuid-85a65ebe-10a2-4a06-a994-d5e7a3bcff3c{fill:url(#uuid-86bb8de9-1e7f-44cd-a172-67ec9a2f8ae5);}.uuid-6021dbf1-982a-49a4-85a1-97a826cbc652{fill:url(#uuid-824c88f6-bcb5-4727-bef1-69259e1acaa6);}.uuid-13583201-fdb1-43a8-a8b3-271a508b8af4{fill:url(#uuid-0a309a07-ea55-45a0-bb92-85d1d183344b);}.uuid-1a2c85b1-8fe4-40db-be1c-d2b6f8c43e37{fill:url(#uuid-3080e025-4be1-4627-9b96-1ba2408b8c3b);}.uuid-a3fb4f95-bc02-4965-9b78-241cb26bb266{fill:url(#uuid-cf0b5723-726b-4345-b7c5-b3c968b7540e);}.uuid-132fc7e1-afc7-45b7-8a74-663d95c33ecd{fill:url(#uuid-9fb6f644-a071-4ee1-a97a-1fb1423a104e);}.uuid-572d6267-88af-4620-9f3a-72d30b9c7a7c{fill:url(#uuid-387445ea-9fc1-463e-9a41-dac6ca60a922);}.uuid-042ec937-9207-42ac-a7f7-7ed60c267ea4{fill:url(#uuid-d504a38f-8ded-499b-aca0-4dd0e702081f);}.uuid-fa9ae6c7-94ce-454b-a914-05d2b828eaaa{fill:url(#uuid-1b21e19b-ee0d-49d8-a7f6-232a97c0fe33);}.uuid-efbc5224-a8cc-4c97-920e-009ec1b6bf45{fill:url(#uuid-a719ec73-1aad-41cc-9e6b-fef5320a992f);}.uuid-dd9b37a8-2fe4-49bf-9af6-340e83887068{fill:url(#uuid-968a10b6-3419-446d-abde-d17fa52de8af);}.uuid-e7dca424-e3fe-4a49-8f5f-4d3100321e43{fill:url(#uuid-5bd7a955-5402-40e3-90e7-8c1224ecee68);}.uuid-7eb5f371-40bf-4ee9-b9ce-677e4f52bca8{fill:url(#uuid-7b73f940-061d-440a-a580-ca1a5253876f);}.uuid-34f547dc-773c-4c42-b2fe-68a0dbee9b22{fill:#182958;}.uuid-2c7a09e4-9fec-422b-8a85-081382ad7c93{fill:url(#uuid-1ccd6a00-95a1-49ca-a5eb-aed8d79f8366);}.uuid-e4c97611-e2f6-4123-a7a9-b096e97afc94{fill:url(#uuid-afbbf497-c5f9-4fe6-857b-3f2f95787112);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-56bbe965-2e74-4407-b9aa-054626ce2fd9",
    x1: 230.16,
    y1: 10690.97,
    x2: 203.44,
    y2: 10692.67,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f67532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99b3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5bd7a955-5402-40e3-90e7-8c1224ecee68",
    x1: 274.81,
    y1: 10686.68,
    x2: 250.18,
    y2: 10686.68,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee5926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f25d2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a719ec73-1aad-41cc-9e6b-fef5320a992f",
    x1: 315.91,
    y1: 10698.68,
    x2: 299.88,
    y2: 10688.18,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee5926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee5926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-10b43388-ad0d-418e-a836-c2a1857d3911",
    x1: 353.29,
    y1: 10716.95,
    x2: 347.04,
    y2: 10707.28,
    xlinkHref: "#uuid-a719ec73-1aad-41cc-9e6b-fef5320a992f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-7b73f940-061d-440a-a580-ca1a5253876f",
    x1: 385.82,
    y1: 10745.34,
    x2: 385.82,
    y2: 10735.81,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3523d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d75436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-968a10b6-3419-446d-abde-d17fa52de8af",
    x1: 413.06,
    y1: 10782.14,
    x2: 413.06,
    y2: 10773,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b3487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#703682"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-44afb8e2-a108-4924-b918-4e7452b1de83",
    x1: 429.77,
    y1: 10826.16,
    x2: 429.77,
    y2: 10814.47,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66368a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693587"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-387445ea-9fc1-463e-9a41-dac6ca60a922",
    x1: 434.68,
    y1: 10874.21,
    x2: 434.68,
    y2: 10857.8,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#473e8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523d8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-0a309a07-ea55-45a0-bb92-85d1d183344b",
    x1: 425.64,
    y1: 10922.27,
    x2: 429.62,
    y2: 10900.48,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#294390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36438f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-cf0b5723-726b-4345-b7c5-b3c968b7540e",
    x1: 403.22,
    y1: 10964.6,
    x2: 414.54,
    y2: 10942.53,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#204093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-afbbf497-c5f9-4fe6-857b-3f2f95787112",
    x1: 368.67,
    y1: 10997.78,
    x2: 390.95,
    y2: 10980.71,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#204093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204093"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-86bb8de9-1e7f-44cd-a172-67ec9a2f8ae5",
    x1: 329.22,
    y1: 11021.57,
    x2: 357.75,
    y2: 11009.95,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c4a9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204093"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-d504a38f-8ded-499b-aca0-4dd0e702081f",
    x1: 315.98,
    y1: 11031.49,
    x2: 284.27,
    y2: 11033.44,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#204093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#116ab6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-824c88f6-bcb5-4727-bef1-69259e1acaa6",
    x1: 238.6,
    y1: 11037.16,
    x2: 270.19,
    y2: 11037.16,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#078cd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b75c0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1ccd6a00-95a1-49ca-a5eb-aed8d79f8366",
    x1: 224.08,
    y1: 11033.09,
    x2: 194.11,
    y2: 11026.75,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0197d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02a9e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-9fb6f644-a071-4ee1-a97a-1fb1423a104e",
    x1: 156.94,
    y1: 11003.03,
    x2: 177.33,
    y2: 11019.13,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00afec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-3080e025-4be1-4627-9b96-1ba2408b8c3b",
    x1: 135.35,
    y1: 10990.04,
    x2: 127.21,
    y2: 10972.6,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02b1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b6f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1b21e19b-ee0d-49d8-a7f6-232a97c0fe33",
    x1: 99.23,
    y1: 10944.81,
    x2: 110.22,
    y2: 10944.81,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b6f0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-34f547dc-773c-4c42-b2fe-68a0dbee9b22",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-553e662b-96f8-48cc-a278-6f53f9cecadd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-801f6152-0582-4948-ab19-45a42a5ec7e3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-136d69f7-754e-442e-9964-ad4421a364eb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-83a470d1-9830-4bae-b321-a7f022756a14",
    className: "uuid-a4f0668e-e2d4-48b5-8cde-8d813c6273f9",
    d: "m69.1,308.93v-104.26h20.51v16.29c3.42-5.16,8.32-9.5,14.52-13.09,6.3-3.54,12.83-5.4,19.57-5.4,23.81,0,35.72,14.36,35.72,42.89v63.57h-20.49v-62.2c0-17.82-7.34-26.36-22.02-25.61-5.16,0-9.86,1.08-13.98,3.28-4.2,2.17-7.5,5.09-9.83,8.84-2.4,3.74-3.61,7.91-3.61,12.52v63.16h-20.39Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-097a959d-cbd9-43b7-bbb1-96db5dccc012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-5d93307b-425d-44d8-a6c4-b2a0585a913c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-5723b8ba-7b1c-4949-827a-5ba8654c6fa6",
    className: "uuid-8e974dc5-f8ad-4336-88b5-f2c5e95ca771",
    d: "m108.69,353.12c-3.07,0-5.54-2.45-5.54-5.52s2.48-5.52,5.54-5.52,5.56,2.48,5.56,5.52-2.5,5.52-5.56,5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-b3997964-d022-4892-bc07-67a458564ee9",
    className: "uuid-8e974dc5-f8ad-4336-88b5-f2c5e95ca771",
    d: "m137.19,393.13c-5.26,0-9.53-4.24-9.53-9.5s4.27-9.53,9.53-9.53,9.5,4.24,9.5,9.53-4.24,9.5-9.5,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-8e619b4c-cde3-448e-b4fe-29aaa7cf154a",
    className: "uuid-8e974dc5-f8ad-4336-88b5-f2c5e95ca771",
    d: "m174.14,423.35c-6.86,0-12.43-5.54-12.43-12.4s5.56-12.38,12.43-12.38,12.43,5.54,12.43,12.38-5.56,12.4-12.43,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-aeb40332-ddd1-4da0-ba90-4769db999f12",
    className: "uuid-07d7321c-c365-4726-a6ad-29573ac92675",
    d: "m216.81,441.18c-7.38,0-13.34-5.97-13.34-13.34s5.97-13.34,13.34-13.34,13.37,5.97,13.37,13.34-5.99,13.34-13.37,13.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-09adbff4-87b7-493f-88da-ecf4cd1bf33b",
    className: "uuid-e7dca424-e3fe-4a49-8f5f-4d3100321e43",
    d: "m262.46,445.3c-6.81,0-12.33-5.49-12.33-12.33s5.52-12.33,12.33-12.33,12.35,5.52,12.35,12.33-5.52,12.33-12.35,12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-f238dec8-4532-4383-a1e4-fb1e04d68b7c",
    className: "uuid-efbc5224-a8cc-4c97-920e-009ec1b6bf45",
    d: "m307.97,435.8c-5.35,0-9.67-4.29-9.67-9.62s4.31-9.62,9.67-9.62,9.64,4.29,9.64,9.62-4.31,9.62-9.64,9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-bb7a3273-58d6-4949-bbe5-612c780adb93",
    className: "uuid-ca6ce922-5a49-4ccc-b845-a54f2980c30b",
    d: "m349.98,414.49c-3.7,0-6.7-2.99-6.7-6.67s2.99-6.7,6.7-6.7,6.72,2.99,6.72,6.7-2.99,6.67-6.72,6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-62a07661-71d9-4507-a620-8d07cae9c937",
    className: "uuid-7eb5f371-40bf-4ee9-b9ce-677e4f52bca8",
    d: "m385.82,383.89c-2.62,0-4.76-2.12-4.76-4.76s2.15-4.74,4.76-4.74,4.76,2.12,4.76,4.74-2.12,4.76-4.76,4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-e38cdf3a-1030-4f63-af02-5630b0494bad",
    className: "uuid-dd9b37a8-2fe4-49bf-9af6-340e83887068",
    d: "m413.07,346.82c-2.55,0-4.6-2.07-4.6-4.62s2.05-4.62,4.6-4.62,4.57,2.05,4.57,4.62-2.05,4.62-4.57,4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-e4d0cff0-e297-4094-9879-8e0630924638",
    className: "uuid-1f1cc64f-df2d-4f47-9383-83725213929a",
    d: "m429.77,305.18c-3.25,0-5.85-2.62-5.85-5.85s2.59-5.85,5.85-5.85,5.85,2.62,5.85,5.85-2.62,5.85-5.85,5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-95eee870-eb76-4f3a-a893-d87a76ea521a",
    className: "uuid-572d6267-88af-4620-9f3a-72d30b9c7a7c",
    d: "m434.67,261.85c-4.53,0-8.21-3.68-8.21-8.21s3.68-8.21,8.21-8.21,8.23,3.65,8.23,8.21-3.68,8.21-8.23,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-eae37828-9bd2-4d33-b295-a40825fa4dac",
    className: "uuid-13583201-fdb1-43a8-a8b3-271a508b8af4",
    d: "m427.65,219.17c-6.04,0-10.92-4.86-10.92-10.87s4.88-10.87,10.92-10.87,10.89,4.86,10.89,10.87-4.88,10.87-10.89,10.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-b1819f7c-e376-46e3-8715-92b6f52def13",
    className: "uuid-a3fb4f95-bc02-4965-9b78-241cb26bb266",
    d: "m409,179.16c-7.14,0-12.92-5.75-12.92-12.87s5.78-12.9,12.92-12.9,12.9,5.78,12.9,12.9-5.75,12.87-12.9,12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-3ed641aa-ac97-4a55-96c6-6518de25716c",
    className: "uuid-e4c97611-e2f6-4123-a7a9-b096e97afc94",
    d: "m380.14,144.71c-7.78,0-14.08-6.3-14.08-14.05s6.3-14.05,14.08-14.05,14.08,6.27,14.08,14.05-6.3,14.05-14.08,14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-b1dba156-827d-41e1-9d4c-2c9eaf764e24",
    className: "uuid-85a65ebe-10a2-4a06-a994-d5e7a3bcff3c",
    d: "m342.93,118.78c-8.39,0-15.16-6.77-15.16-15.11s6.77-15.11,15.16-15.11,15.14,6.74,15.14,15.11-6.77,15.11-15.14,15.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-1e06724a-0abe-4152-b3cb-83c61f0087db",
    className: "uuid-042ec937-9207-42ac-a7f7-7ed60c267ea4",
    d: "m300.07,103c-8.77,0-15.84-7.07-15.84-15.82s7.07-15.82,15.84-15.82,15.84,7.07,15.84,15.82-7.07,15.82-15.84,15.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-8c2c76ce-b14e-4833-855f-4e96acce4b91",
    className: "uuid-6021dbf1-982a-49a4-85a1-97a826cbc652",
    d: "m254.42,98.29c-8.75,0-15.82-7.07-15.82-15.8s7.07-15.8,15.82-15.8,15.82,7.05,15.82,15.8-7.07,15.8-15.82,15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-56ca6485-88c5-43ce-b37b-fecb54132a9e",
    className: "uuid-2c7a09e4-9fec-422b-8a85-081382ad7c93",
    d: "m209.01,104.7c-8.3,0-15-6.7-15-14.95s6.7-14.95,15-14.95,15.02,6.67,15.02,14.95-6.72,14.95-15.02,14.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-080c4dfd-6bf3-419c-9826-5a7890c8a932",
    className: "uuid-132fc7e1-afc7-45b7-8a74-663d95c33ecd",
    d: "m167.09,121.7c-7.24,0-13.11-5.85-13.11-13.09s5.87-13.11,13.11-13.11,13.11,5.85,13.11,13.11-5.85,13.09-13.11,13.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-916ac7d1-c32a-4775-bace-f2b60024e98a",
    className: "uuid-1a2c85b1-8fe4-40db-be1c-d2b6f8c43e37",
    d: "m131.6,147.21c-5.3,0-9.6-4.29-9.6-9.6s4.29-9.6,9.6-9.6,9.62,4.29,9.62,9.6-4.29,9.6-9.62,9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-4c6003eb-f626-4dc5-80cd-b8e8938a1120",
    className: "uuid-fa9ae6c7-94ce-454b-a914-05d2b828eaaa",
    d: "m104.75,180.36c-3.04,0-5.52-2.48-5.52-5.52s2.48-5.52,5.52-5.52,5.52,2.48,5.52,5.52-2.45,5.52-5.52,5.52Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNvax);
export default __webpack_public_path__ + "static/media/icon_nvax.f68f55f6e8f6b90d22544f0c5883e60f.svg";
export { ForwardRef as ReactComponent };